<template>
  <div class="container mycontainer">
    <table class="table text-center atable">
      <thead>
          <tr>
            <th v-if="fullHeaders">Fundamental Frequency Ratio - 1.0</th>
            <th v-else>Fundamental Ratio</th>
            <th v-for="(value) in steps"> {{value}}</th>
          </tr>
          <tr v-if="fullHeaders">
            <th :style="styleLabel()">Interval</th>
            <th v-for="(name,i) in names" :key="names[i]" :style="styleNote(i)">{{name}}</th>
          </tr>
          <tr v-else>
            <th :style="styleLabel()">Interval</th>
            <th v-for="(name,i) in shortNames" :key="shortNames[i]" :style="styleNote(i)">{{name}}</th>
          </tr>
      </thead>
      <tbody>
          <tr>
            <td>Chromatic</td>
            <td v-for="n in 12+1">{{notes[n-1]}}</td>
          </tr>
          <tr>
            <td>Whole Tone</td>
            <td v-for="(value,i) in wholeToneScale" v-if="hasValue(value,i)">{{notes[i]}}</td>
            <td v-else>&nbsp;</td>
          </tr>

          <tr v-if="fullHeaders">
            <th :style="styleLabel()">diatonic major</th>
            <th v-for="(name,i) in diatonicMajor" :key="diatonicMajor[i]" :style="styleNote(i)">{{name}}</th>
          </tr>
          <tr>
            <td>Major</td>
            <td v-for="(value,i) in majorScale" v-if="hasValue(value,i)">{{notes[i]}}</td>
            <td v-else>&nbsp;</td>
          </tr>

          <tr v-if="fullHeaders">
            <th :style="styleLabel()">diatonic minor</th>
            <th v-for="(name,i) in diatonicMinor" :key="diatonicMinor[i]" :style="styleNote(i)">{{name}}</th>
          </tr>
          <tr>
            <td>Natural Minor</td>
            <td v-for="(value,i) in minorScale" v-if="hasValue(value,i)">{{notes[i]}}</td>
            <td v-else>&nbsp;</td>
          </tr>
          <tr>
            <td>Melodic Minor</td>
            <td v-for="(value,i) in melodicScale" v-if="hasValue(value,i)">{{notes[i]}}</td>
            <td v-else>&nbsp;</td>
          </tr>
          <tr>
            <td>Harmonic Minor</td>
            <td v-for="(value,i) in harmonicScale" v-if="hasValue(value,i)">{{notes[i]}}</td>
            <td v-else>&nbsp;</td>
          </tr>

          <tr v-if="fullHeaders">
            <th :style="styleLabel()">Pentatonic Scales</th>
            <td colspan="13">&nbsp;</td>
          </tr>
          <tr>
            <td>Pentatonic Major</td>
            <td v-for="(value,i) in pentatonicMajorScale" v-if="hasValue(value,i)">{{notes[i]}}</td>
            <td v-else>&nbsp;</td>
          </tr>
          <tr>
            <td>Pentatonic Minor</td>
            <td v-for="(value,i) in pentatonicMinorScale" v-if="hasValue(value,i)">{{notes[i]}}</td>
            <td v-else>&nbsp;</td>
          </tr>
          <tr>
            <td>Blues Minor</td>
            <td v-for="(value,i) in bluesScale" v-if="hasValue(value,i)">{{notes[i]}}</td>
            <td v-else>&nbsp;</td>
          </tr>
      </tbody>
    </table>

    <table v-if="!fullHeaders" class="table text-center btable">
      <tr>
        <td :style="styleLabel()">
          &nbsp;
        </td>
        <td :style="padStep()">&nbsp;</td>
        <td v-for="i in 12" :key="i" v-if="i <= numSteps" :style="styleStep(i)">
          &nbsp;
        </td>
        <td :style="padStep()">
          &nbsp;
        </td>
      </tr>
    </table>

  </div>
</template>

<script>
  import * as MusicData from '@/data/music_data'

  export default {
    name: 'ScalesSheet',
    props: {
      tonic: {
        type: String,
        default: "C"
      },
      numSteps: {
        Type: Number,
        default: 4
      },
      fullHeaders: {
        Type: Boolean,
        default: false
      }
    },
    data () {
      return {
        relwLabel: 0.2000,
        relwNotes: [0.0833,0.0625,0.0792,0.0625,0.0667,0.0781,0.0833,0.0969,0.0833,0.1000,0.1042,0.1000,0.0833],
        relwTotal: 1.2834,
        relwPad:   0.0417,
        relwSteps: 1.0000,

        steps: MusicData.steps,
        ratios: MusicData.ratios,
        cycles: MusicData.cycles,
        names: MusicData.names,
        shortNames: MusicData.shortNames,
        diatonicMajor: MusicData.diatonicMajor,
        diatonicMinor: MusicData.diatonicMinor,

        notes: [],
        wholeToneScale : MusicData.wholeToneScale,
        majorScale : MusicData.majorScale,
        minorScale : MusicData.minorScale,
        melodicScale : MusicData.melodicMinorScale,
        harmonicScale : MusicData.harmonicMinorScale,
        pentatonicMajorScale : MusicData.pentatonicMajorScale,
        pentatonicMinorScale : MusicData.pentatonicMinorScale,
        bluesScale : MusicData.bluesScale,
        penta6Scale: MusicData.penta6Scale,
      }
    },
    mounted: function () {
      this.tonic = 'C';
      this.notes = MusicData.chromaticScales[this.tonic];
    },
    watch: {
      /* eslint-disable-next-line */
      tonic: function (newTonic, oldTonic) {
        this.notes = MusicData.chromaticScales[newTonic]
      },
      /* eslint-disable-next-line */
      numSteps: function(newSteps, oldSteps) {
      }
    },
    methods: {
      hasValue (value,i) {
        return typeof value !== 'undefined' && typeof this.notes !== 'undefined' && i < this.notes.length
      },
      styleLabel () {
        return {
          'width': this.relwLabel / this.relwTotal * 100 + '%'
        }
      },
      styleNote (i) {
        return {
          'width': this.relwNotes[i] / this.relwTotal * 100 + '%'
        }
      },
      padStep () {
        return {
          'width': this.relwPad / this.relwTotal * 100 + '%'
        }
      },
      styleStep(i) {
        let bgcolor = "rgba(0,192,0,0.15)"
        if (i % 3 == 2)
          bgcolor = "rgba(0,192,0,0.10)"
        else if (i % 3 == 0)
          bgcolor = "rgba(0,192,0,0.05)"
        return {
          'width': (this.relwSteps / this.numSteps) / this.relwTotal * 100 + '%',
          'background-color': bgcolor
        }
      }
    }
  }
</script>

<style>
.mycontainer {
  position: relative;
}
.atable {
  width: 100%;
  background-color: rgba(255, 255, 255, 0.027);
}
.btable {
  position: relative;
  top:0;
  left:0;
  width: 100%;
}
</style>
